
import { DashboardAPI } from "@/services/api/Dashboard.service";
import {
  defineComponent,
  ref,
  onMounted,
  PropType,
  toRef,
  watch,
  computed,
} from "vue";
import {
  IDashboardFormLineSeries,
  IDashboardFormLineData,
  IDashboardFormSingleLineData,
} from "@/interfaces/iDashboard";
import { dashboardLineChartOptions } from "@/views/form/components/formDashboardConfig";
import { SITE_STORE, GET_SELECTED_SITES_STR } from "@/store/userSite/types";
import store from "@/store";
import moment from "moment";

interface IDateFilterValue {
  startDate: "";
  endDate: "";
}
export default defineComponent({
  name: "line-chart",
  props: {
    dateFilterValue: {
      type: Object as PropType<IDateFilterValue>,
      required: true,
    },
    reference: { type: String, default: "" },
    webId: { type: Number, default: 0 },
    column: { type: Boolean, default: false },
    height: {
      type: [String, Number],
      default: "auto",
    },
    userSiteId: { type: [String, Number], default: "" },
  },
  setup(props) {
    const dateFilterValue = toRef(props, "dateFilterValue");
    const column = toRef(props, "column");
    const lineSeries = ref<Array<IDashboardFormLineSeries>>([]);
    const lineChartOptions = ref(dashboardLineChartOptions());
    const LineChartData = ref<Array<IDashboardFormLineData>>([]);
    const uniqueTypesForLineChart = ref<Array<string>>([]);
    const uniqueDatesForLineChart = ref<Array<string>>([]);
    const singleLineData = ref<Array<IDashboardFormSingleLineData>>([]);
    const lineChartLoading = ref(false);
    const referURL = toRef(props, "reference");
    const mainWebId = toRef(props, "webId");
    const chart = ref<null | HTMLFormElement>(null);
    const getLineChartData = async () => {
      // if (mainWebId.value < 1) {
      //   return;
      // }
      try {
        lineChartLoading.value = true;
        chart.value?.destroy();
        const response = await DashboardAPI.getInstance().getLineChartData(
          moment(dateFilterValue.value.startDate)
            .startOf("day")
            .format("YYYY-MM-DDTHH:mm:ssZ"),
          dateFilterValue.value.endDate,
          referURL.value,
          mainWebId.value,
          props.userSiteId
        );
        LineChartData.value = response;
        lineChartLoading.value = false;
        LineChartData.value.forEach((data, index) => {
          uniqueTypesForLineChart.value.push(data.type);
          uniqueDatesForLineChart.value.push(data.date);
        });
        uniqueTypesForLineChart.value = uniqueTypesForLineChart.value.filter(
          (c, index) => {
            return uniqueTypesForLineChart.value.indexOf(c) === index;
          }
        );
        uniqueDatesForLineChart.value = uniqueDatesForLineChart.value.filter(
          (c, index) => {
            return uniqueDatesForLineChart.value.indexOf(c) == index;
          }
        );
        uniqueDatesForLineChart.value.forEach((data, index) => {
          lineChartOptions.value.xaxis.categories.push(data);
        });
        if (lineChartOptions.value.xaxis.categories[0] == "") {
          lineChartOptions.value.xaxis.categories.shift();
        }
        window.dispatchEvent(new Event("resize"));
        setLineChartXaxis(
          uniqueTypesForLineChart.value,
          uniqueDatesForLineChart.value,
          LineChartData.value
        );
      } catch (e) {
        console.log(e);
      }
    };
    const setLineChartXaxis = async (types, dates, allLineData) => {
      singleLineData.value = [];
      uniqueTypesForLineChart.value.forEach((singleType, indexTypes) => {
        let object = {
          name: "",
          data: [],
        };
        if (singleType == "ON_TIME") {
          object.name = "On Time";
        } else if (singleType == "OUTSIDE_PERIOD") {
          object.name = "Outside Period";
        } else {
          object.name = "Expired";
        }
        singleLineData.value.push(object);
      });
      let filteredData = singleLineData.value.filter(
        (item, index, array) =>
          !array.slice(0, index).some((prevItem) => prevItem.name === item.name)
      );
      lineSeries.value = filteredData;
      dates.forEach((uniqueDate, indexUnique) => {
        allLineData.forEach((allData, indexAll) => {
          if (uniqueDate == allData.date) {
            types.forEach((singleUniqueType, indexTypes) => {
              if (allData.type == singleUniqueType) {
                lineSeries.value[indexTypes].data.push(allData.count);
              }
            });
          }
        });
      });
    };
    onMounted(() => {
      // getLineChartData();
    });
    // watch(
    //   mainWebId,
    //   () => {
    //     console.log("watcher");
    //     LineChartData.value = [];
    //     uniqueTypesForLineChart.value = [];
    //     uniqueDatesForLineChart.value = [];
    //     lineChartOptions.value.xaxis.categories = [];
    //     singleLineData.value = [];
    //     lineSeries.value = [];
    //     getLineChartData();
    //   },
    //   { deep: true, immediate: true }
    // );
    const selectedSites = computed(() => {
      const key = `${SITE_STORE}/${GET_SELECTED_SITES_STR}`;
      return store.getters[key] as string;
    });

    watch(selectedSites, async () => {
      lineChartLoading.value = true;
      LineChartData.value = [];
      uniqueTypesForLineChart.value = [];
      uniqueDatesForLineChart.value = [];
      lineChartOptions.value.xaxis.categories = [];
      singleLineData.value = [];
      lineSeries.value = [];
      await getLineChartData();
    });
    watch(
      [dateFilterValue, mainWebId],
      ([one, two]) => {
        lineChartLoading.value = true;
        LineChartData.value = [];
        uniqueTypesForLineChart.value = [];
        uniqueDatesForLineChart.value = [];
        lineChartOptions.value.xaxis.categories = [];
        singleLineData.value = [];
        lineSeries.value = [];
        getLineChartData();
      },
      { deep: true, immediate: true }
    );
    return {
      lineChartOptions,
      lineSeries,
      lineChartLoading,
      referURL,
      chart,
    };
  },
});
